









//////////////////////
//      Imports     //
//////////////////////
import Vue from "vue";
import { useStore } from "@/store/store";
import { mapStores } from "pinia";
import { findAddCommandFrameType } from "@/helpers/editor";
import { PythonExecRunningState } from "@/types/types";
import SVGIcon from "@/components/SVGIcon.vue";

//////////////////////
//     Component    //
//////////////////////
export default Vue.extend({
    name: "AddFrameCommand",

    components: {
        SVGIcon,
    },

    props: {
        type: String, //Type of the Frame Command
        shortcut: String, //the keyboard shortcut to add the frame 
        symbol: String, //the displayed shortcut in the UI, it can be a symbolic representation or (if specified) a SVGIcon name
        isSVGIconSymbol: Boolean, // if true, the symbol property is the name of a SVGIcon
        description: String, //the description of the frame
        index: Number, //when more than 1 frame is assigned to a shortcut, the index tells which frame definition should be used
    },

    computed: {
        ...mapStores(useStore),

        isLargerShorcutSymbol() {
            return this.symbol.length > 1 && !this.isSVGIconSymbol;
        },

        isPythonExecuting(): boolean {
            return (useStore().pythonExecRunningState ?? PythonExecRunningState.NotRunning) != PythonExecRunningState.NotRunning;
        },
    },

    methods: {
        onClick(): void {
            //add the frame in the editor if the panel is not disabled
            if(!this.isPythonExecuting) {
                const addFrameCommandType = findAddCommandFrameType(this.shortcut, this.index);
                if(addFrameCommandType != null){
                    this.appStore.addFrameWithCommand(addFrameCommandType);
                }
            }
        },
    },
});
